export default "__VITE_ASSET__BaP_OEkR__"